export const ADSENSE_CONFIG = {
  isEnabled: true,
  clientId: '6911267030368068'
};
